/** Opções do campo "Tipo de Atividade" (atividades complementares — portfolio). */
export const complementaryActivityTypeSelectOptions: {
  title: string;
  value: string;
}[] = [
  { title: '[ SELECIONE ]', value: '' },
  { title: 'Iniciação Científica', value: 'Iniciação Científica' },
  {
    title: 'Publicação de Trabalho de Pesquisa',
    value: 'Publicação de Trabalho de Pesquisa',
  },
  {
    title:
      'Participação em Projetos de Pesquisa Institucional ou docente',
    value:
      'Participação em Projetos de Pesquisa Institucional ou docente',
  },
  {
    title:
      'Participação em Palestras, Seminários, Simpósios e Congressos',
    value:
      'Participação em Palestras, Seminários, Simpósios e Congressos',
  },
  {
    title: 'Participação como Debatedor em Eventos',
    value: 'Participação como Debatedor em Eventos',
  },
  {
    title: 'Apresentação de Trabalhos em Eventos na Área',
    value: 'Apresentação de Trabalhos em Eventos na Área',
  },
  { title: 'Visitas Técnicas', value: 'Visitas Técnicas' },
  {
    title: 'Projetos em Extensão em áreas afins do curso',
    value: 'Projetos em Extensão em áreas afins do curso',
  },
  {
    title: 'Cursos de Extensão em áreas afins do curso',
    value: 'Cursos de Extensão em áreas afins do curso',
  },
  {
    title: 'Cursos de Extensão em geral',
    value: 'Cursos de Extensão em geral',
  },
  {
    title: 'Atividades Socioculturais ou trabalho voluntário',
    value: 'Atividades Socioculturais ou trabalho voluntário',
  },
  { title: 'Monitoria', value: 'Monitoria' },
  {
    title: 'Participação em Juris e Audiências',
    value: 'Participação em Juris e Audiências',
  },
  {
    title: 'Gestão ou representação estudantil',
    value: 'Gestão ou representação estudantil',
  },
  { title: 'Curso de informática', value: 'Curso de informática' },
  {
    title: 'Cursos de idiomas ou Libras',
    value: 'Cursos de idiomas ou Libras',
  },
  {
    title: 'Cursos realizados a distância',
    value: 'Cursos realizados a distância',
  },
  {
    title: 'Programação de Nivelamento',
    value: 'Programação de Nivelamento',
  },
  { title: 'Preparatório Enade', value: 'Preparatório Enade' },
  {
    title: 'Estágio Extracurricular (não obrigatório)',
    value: 'Estágio Extracurricular (não obrigatório)',
  },
  { title: 'Outras atividades', value: 'Outras atividades' },
];

/** Opções do campo "Tipo" (documentos do estágio — portfolio). */
export const internshipDocumentTypeSelectOptions: {
  title: string;
  value: string;
}[] = [
  { title: '[ SELECIONE ]', value: '' },
  {
    title: 'RELATÓRIO COMPLETO DO ESTÁGIO',
    value: 'RELATÓRIO COMPLETO DO ESTÁGIO',
  },
  { title: 'CAPA', value: 'CAPA' },
  { title: 'CONTRACAPA', value: 'CONTRACAPA' },
  {
    title: 'CARTA DE APRESENTAÇÃO',
    value: 'CARTA DE APRESENTAÇÃO',
  },
  {
    title: 'TERMO DE COMPROMISSO',
    value: 'TERMO DE COMPROMISSO',
  },
  {
    title: 'CONVÊNIO DE ESTÁGIO',
    value: 'CONVÊNIO DE ESTÁGIO',
  },
  {
    title: 'PERFIL DO (A) ALUNO (A) ESTAGIÁRIO',
    value: 'PERFIL DO (A) ALUNO (A) ESTAGIÁRIO',
  },
  {
    title: 'PLANO DE ATIVIDADES DO ESTAGIO',
    value: 'PLANO DE ATIVIDADES DO ESTAGIO',
  },
  {
    title: 'REGISTRO DE OBSERVAÇÃO DA INSTITUIÇÃO',
    value: 'REGISTRO DE OBSERVAÇÃO DA INSTITUIÇÃO',
  },
  { title: 'FICHA DE OBSERVAÇÃO', value: 'FICHA DE OBSERVAÇÃO' },
  { title: 'FICHA DE INTERVENÇÃO', value: 'FICHA DE INTERVENÇÃO' },
  { title: 'REGISTRO DE HORAS', value: 'REGISTRO DE HORAS' },
  {
    title: 'PLANO DE INTERVENÇÃO',
    value: 'PLANO DE INTERVENÇÃO',
  },
  {
    title: 'FICHA DE AVALIAÇÃO DO ESTÁGIÁRIO',
    value: 'FICHA DE AVALIAÇÃO DO ESTÁGIÁRIO',
  },
  {
    title: 'FICHA DE AVALIAÇÃO DAS ANAMNESES E INTERVENÇÕES',
    value: 'FICHA DE AVALIAÇÃO DAS ANAMNESES E INTERVENÇÕES',
  },
  {
    title: 'FICHA DE AUTOAVALIAÇÃO DO ESTAGIÁRIO',
    value: 'FICHA DE AUTOAVALIAÇÃO DO ESTAGIÁRIO',
  },
];
